import { jsx as r } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ r(
  "path",
  {
    fill: "currentColor",
    d: "M21.593 7.203a2.505 2.505 0 0 0 -1.762 -1.766C18.265 5.007 12 5 12 5s-6.264 -0.007 -7.831 0.404a2.558 2.558 0 0 0 -1.766 1.778c-0.413 1.566 -0.417 4.814 -0.417 4.814s-0.004 3.264 0.406 4.814a2.505 2.505 0 0 0 1.763 1.766c1.583 0.43 7.83 0.436 7.83 0.436s6.265 0.007 7.831 -0.403a2.513 2.513 0 0 0 1.767 -1.763c0.414 -1.565 0.417 -4.813 0.417 -4.813s0.02 -3.265 -0.407 -4.83M9.997 15.005l0.005 -6 5.207 3.005z"
  }
);
export {
  o as default
};
